export const QUERY_KEY_RELATED_ACCOUNTS = 'related-accounts';
export const QUERY_KEY_MULTI_ACCOUNTS = 'multi-accounts';
